/* Exact category searches open the same collections used by the menus.
   Qualified searches and filters retain Shopify's matching-product results. */
(() => {
  const data = document.getElementById('fp-search-category-routes');
  if (!data) return;
  let config;
  try { config = JSON.parse(data.textContent); } catch { return; }
  const normalize = (value) => String(value || '').normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const isSearch = (url) => /\/search\/?$/.test(url.pathname);
  const destination = (url) => {
    if (!isSearch(url) || url.origin !== location.origin) return null;
    if ([...url.searchParams.keys()].some((key) => key.startsWith('filter.') || key === 'sort_by')) return null;
    return config.routes[normalize(url.searchParams.get('q'))] || null;
  };
  const navigate = (path, replace = false) => {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) return;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    if (replace) location.replace(url.href); else location.assign(url.href);
  };
  const current = new URL(location.href);
  const category = destination(current);
  const unfiltered = ![...current.searchParams.keys()].some((key) => key.startsWith('filter.') || key === 'sort_by');
  if (category || (isSearch(current) && unfiltered && current.searchParams.get('q')?.trim() && config.singleProduct)) {
    navigate(category || config.singleProduct, true);
    return;
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.origin);
    if (!isSearch(url)) return;
    for (const [key, value] of new FormData(form)) if (typeof value === 'string') url.searchParams.set(key, value);
    const target = destination(url);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigate(target);
  }, true);
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const target = destination(new URL(link.href));
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigate(target);
  }, true);
})();
